export const getGatedContentCheckedFields = state => state.gated_content.checked_fields || [];
